export default {
  GET_WEBSOCKET_STATUS: (state) => {
    return state.websocketStatus;
  },

  GET_WEBSOCKET_CONNECTION_ID: (state) => {
    return state.websocketConnectionId;
  },
};
